export default __webpack_public_path__ + "static/media/my-surviour.f1888c86.svg";